import { MutationOptions } from 'react-query';
import { queryClient } from '../../../queryClient';
import { updateOrg } from './orgs.api';
import { UpdateOrgRequest, UpdateOrgResponse } from './orgs.schema';
import { ORGS_QUERY_KEY_PREFIX } from './orgs.query';

export const getUpdateOrgMutation = (
  orgId: number,
): MutationOptions<UpdateOrgResponse, Error, UpdateOrgRequest> => ({
  mutationFn: data => updateOrg(orgId, data),
  onSuccess: () =>
    queryClient.invalidateQueries({
      queryKey: [{ scope: ORGS_QUERY_KEY_PREFIX }],
      exact: false,
    }),
});
